// extracted by mini-css-extract-plugin
export default {"pageContainer":"Statistics_pageContainer__jQpOQ","header":"Statistics_header__ufR3M","content":"Statistics_content__JVYLc","datePicker":"Statistics_datePicker__jxlap"};